import produce from "immer";

import { militaryReservistOrgNames } from "../../lib/types/runtimeTypes";
import {
  type VerificationService,
  type FormSelectChoice,
  type ActiveMilitaryPersonalInfoViewModel,
  type InactiveMilitaryPersonalInfoViewModel,
  type MilitaryStatus,
  type Organization,
} from "../../lib/types/types";

/**
 * @deprecated Do org search with `?tag={status}`, instead.
 * Kept here for es6 export, for now
 * e.g. ?tag=RESERVIST&country=US
 */
export const orgsInStatus = (status: MilitaryStatus) => (org: Organization) => {
  if (status === "RESERVIST") {
    return militaryReservistOrgNames.includes(org.name);
  }
  if (status === "ACTIVE_DUTY") {
    return !militaryReservistOrgNames.includes(org.name);
  }
  return !!org.name;
};

export const updateMilitaryViewModel = (
  key: keyof ActiveMilitaryPersonalInfoViewModel | keyof InactiveMilitaryPersonalInfoViewModel,
  value: any,
  verificationService: VerificationService,
  availableStatuses: FormSelectChoice[],
): ActiveMilitaryPersonalInfoViewModel | InactiveMilitaryPersonalInfoViewModel => {
  const viewModel = verificationService.viewModel as ActiveMilitaryPersonalInfoViewModel;
  const nextState: ActiveMilitaryPersonalInfoViewModel = produce(
    viewModel,
    (draft: ActiveMilitaryPersonalInfoViewModel) => {
      (draft[key] as any) = value;

      draft.fieldsToSkipValidation = [];

      // If there are no status choices, don't validate
      if (!availableStatuses) {
        draft.fieldsToSkipValidation.push("status");
      }

      if (
        !verificationService.programTheme.transitionalMilitaryValidityDays &&
        !(
          verificationService.verificationResponse.currentStep ===
          "collectInactiveMilitaryPersonalInfo"
        )
      ) {
        draft.fieldsToSkipValidation.push("dischargeDate");
      }

      if (key === "status") {
        draft.organization = {
          id: 0,
          name: "",
        };
      }
    },
  );
  return nextState;
};
